import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const getSearch = createAsyncThunk("getSearch", async (search) => {
  return search;
});
export const setFilterLocation = createAsyncThunk("getFilterLocation", async (search) => {
  return search;
});

const searchSlice = createSlice({
  name: "search",
  initialState: {
    search:'',
    filterLocation:"default",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSearch.fulfilled, (state, action) => {
      state.search = action.payload;
    });
    builder.addCase(setFilterLocation.fulfilled, (state, action) => {
      state.filterLocation = action.payload;
    });

  },
});

export default searchSlice.reducer;
